module.exports = __webpack_public_path__ + "img/Value.9c10c11c.png";